import { ISelectOption } from "lobbie";

// eslint-disable-next-line
export enum ESexAssignedAtBirth {
    UNKNOWN = 0,
    MALE = 1,
    FEMALE = 2,
    OTHER = 3,
    NOT_SPECIFIED = 4,
}

// eslint-disable-next-line
export enum ELegalSex {
    UNKNOWN = 0,
    MALE = 1,
    FEMALE = 2,
}

export const SEX_ASSIGNED_AT_BIRTH_STRING_BY_NUMBER = {
    [ESexAssignedAtBirth.UNKNOWN]: "Unknown",
    [ESexAssignedAtBirth.MALE]: "Male",
    [ESexAssignedAtBirth.FEMALE]: "Female",
    [ESexAssignedAtBirth.OTHER]: "Other",
    [ESexAssignedAtBirth.NOT_SPECIFIED]: "Not Specified",
};

export const LEGAL_SEX_STRING_BY_NUMBER = {
    [ELegalSex.UNKNOWN]: "Unknown",
    [ELegalSex.MALE]: "Male",
    [ELegalSex.FEMALE]: "Female",
};

export const SEX_ASSIGNED_AT_BIRTH_OPTIONS = [
    { label: "Male", value: ESexAssignedAtBirth.MALE },
    { label: "Female", value: ESexAssignedAtBirth.FEMALE },
] as ISelectOption[];

export const LEGAL_SEX_OPTIONS = [
    { label: "Unknown", value: ELegalSex.UNKNOWN },
    { label: "Male", value: ELegalSex.MALE },
    { label: "Female", value: ELegalSex.FEMALE },
] as ISelectOption[];
